// src/pages/AdminSuspended.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ShieldOff } from 'lucide-react';

const AdminSuspended = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    // clear tokens just in case
    localStorage.removeItem('authToken');
    localStorage.removeItem('authRole');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('authRole');

    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-slate-900 border border-red-500/40 rounded-2xl p-8 shadow-xl text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
            <ShieldOff className="w-9 h-9 text-red-400" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-red-300 mb-2">
          Subscription Suspended
        </h1>
        <p className="text-sm text-slate-300 mb-4">
          Your company&apos;s Patrol Visit license is currently suspended.
        </p>
        <p className="text-xs text-slate-400 mb-8">
          Please contact the system administrator or billing team to restore
          access. Once your subscription is reactivated, you will be able to log
          in again.
        </p>

        <button
          onClick={handleBackToLogin}
          className="w-full py-3 rounded-xl bg-red-500 hover:bg-red-600 text-white font-semibold text-sm transition-colors"
        >
          Back to Login
        </button>

        <div className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500">
          <AlertTriangle className="w-3 h-3" />
          <span>All actions are temporarily disabled for this tenant.</span>
        </div>
      </div>
    </div>
  );
};

export default AdminSuspended;